import { Box, Button, useMediaQuery, useTheme, Typography } from '@mui/material';

export const CodeConductPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const pdfUrl = 'codigo_conduta_interno.pdf';

  if (isMobile) {
    // Fallback para dispositivos móveis
    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="h6" mb={2}>
          Código de Conduta
        </Typography>
        <Typography mb={1}>
          Seu dispositivo não suporta exibição do PDF embutido. Clique no botão
          para abrir o documento:
        </Typography>
        <Button 
          variant="contained"
          onClick={() => window.open(pdfUrl, '_blank')}
        >
          Abrir PDF
        </Button>
      </Box>
    );
  }

  // Para telas maiores, exibe em <iframe>
  return (
    <Box sx={{ mt: 2 }}>
      <Box
        component="iframe"
        src={pdfUrl}
        width="100%"
        height="800px"
      />
    </Box>
  );
};
